import { Checkbox, FormControlLabel } from '@mui/material'
import { useController } from '../../../../../hooks/useController'
import { useTexts } from '../../../../../useTexts'

const includePodTestId = 'export-order-include-pod'

export function IncludePod() {
  const texts = useTexts()

  const {
    data: { includePod },
    updateData,
  } = useController()

  return (
    <FormControlLabel
      data-testid={includePodTestId}
      data-trackid={includePodTestId}
      control={
        <Checkbox
          size="small"
          checked={includePod}
          onChange={e => updateData({ includePod: e.target.checked })}
        />
      }
      label={texts.exportOrdersIncludePod}
      sx={{ ml: 2.5 }}
    />
  )
}
